const WithdrawalTab: React.FC = () => {
  return (
    <div className="rounded-xl border bg-white p-6">
      <h2 className="text-xl font-semibold">Withdrawal</h2>
      <p className="mt-2 text-gray-500">Withdrawal options and rules.</p>
    </div>
  );
};

export default WithdrawalTab;
